import * as analytics from 'analytics/Analytics';
import {ACTION_CATEGORY, ANALYTICS_MODULE, ActionOrigin} from 'constants/AnalyticsConstants';
import {getEntryOrFileIdKey} from 'notebook/util/analytics/FileAnalyticsUtils';

type AddSamplesActionOrigin = ActionOrigin.NOTEBOOK;
type AddSamplesSourceType =
  | 'structured_table'
  | 'worklist'
  | 'spreadsheet'
  | 'box'
  | 'plate'
  | 'barcode_scan';
type AddSamplesTableType = 'inventory_table';
type AddSamplesSampleType = 'container' | 'plate_or_well';

export interface CompleteAddSamplesTrackingParams {
  module: keyof typeof ANALYTICS_MODULE;
  actionOrigin: AddSamplesActionOrigin;
  sessionId?: string;
  entryId: string | null;
  structuredTableId: string | null;
  sourceId: string | null;
  sourceType: AddSamplesSourceType;
  numSamples: number;
  sampleType: AddSamplesSampleType;
  schemaId: string | null;
  tableType: AddSamplesTableType;
}

export type AddSamplesToTableTrackingParams = Omit<
  CompleteAddSamplesTrackingParams,
  'numSamples' | 'sourceId' | 'sourceType'
>;

export interface AddSamplesTrackingMetadata {
  action_origin: ActionOrigin;
  addition_method: string;
  structured_table_id: string | null;
  entry_id?: string | null;
  file_id?: string | null;
  source_id: string | null;
  source_type: string;
  num_samples: number;
  sample_type: string;
  schema_id: string | null;
  session_id: string | null;
}

function getMetadataFromParams(params: CompleteAddSamplesTrackingParams): AddSamplesTrackingMetadata {
  const fileIdKey = getEntryOrFileIdKey(params.entryId);
  return {
    action_origin: params.actionOrigin,
    addition_method:
      params.sourceType === 'box' || params.sourceType === 'plate' ? 'box_or_plate' : params.sourceType,
    structured_table_id: params.structuredTableId,
    source_id: params.sourceId,
    source_type: params.sourceType,
    num_samples: params.numSamples,
    sample_type: params.sampleType,
    schema_id: params.schemaId,
    session_id: params.sessionId ?? null,
    [fileIdKey]: params.entryId,
  };
}

export function trackAddSamples(params: CompleteAddSamplesTrackingParams): void {
  analytics.trackEvent(
    {
      module: ANALYTICS_MODULE[params.module],
      action: `added_samples_${params.tableType}`,
      actionCategory: ACTION_CATEGORY.WRITE,
    },
    getMetadataFromParams(params)
  );
}
